import { AppRouter } from '@app/providers/router';

function App() {
  return <AppRouter />;
}

export default App;
